<template>
  <div class="base-progress-bar" :class="{'disabled': score === 0 }">
    <slot name="text-before">
      <span class="base-progress-bar__text">{{ textBefore }}</span>
    </slot>
    <div class="relative w-full">
      <div class="base-progress-bar__bar" />
      <div class="base-progress-bar__bar active" :style="{'width': activeWidth}" />
    </div>
    <slot name="text-after">
      <span class="base-progress-bar__text">{{ textAfter }}</span>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    textBefore: {
      type: Number,
      default: 0
    },
    textAfter: {
      type: String,
      default: ''
    },
    max: {
      type: Number,
      default: 5
    },
    score: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      width: 0
    }
  },
  computed: {
    activeWidth () {
      return this.width + '%'
    }
  },
  mounted () {
    this.width = Math.floor((this.score / this.max) * 100)
  }
}
</script>

<style scoped lang="scss">
.base-progress-bar {
  @apply flex items-center space-x-3 text-label-text;
  &__bar {
    @apply w-full h-1 bg-border-cart rounded;
    &.active {
      @apply bg-primary absolute top-0 left-0 z-10 transition-[width] delay-300;
    }
  }
  &__text {
    @apply whitespace-nowrap text__body-2-md--regular text-body-2;
  }
}
.disabled {
  .base-progress-bar__text {
    @apply text-label-text;
  }
}
</style>
